/* eslint-disable no-unused-vars */

import Vue from 'vue'
import Vuex from 'vuex'
import queryString from 'query-string'
import { Base64 } from 'js-base64'
import { $http, http } from '@/utils/http'
import { Message } from 'ant-design-vue'
import popHome from './home-pop'
import partnerHome from './home-partner'
import brandHome from './home-brand'
import dfwHome from './home-dfw'
import template from './template'
import heatmap from './heatmap'
import host from "@/utils/host";
import jsCookie from 'js-cookie'
import { toLogin, setCookie, isLeYou } from "@/utils/utils";
import KWLogin from 'kw-bweb-login'
import { report } from '@/utils/reportError'
import { hasNeedLoginKeyWords } from '@/utils/handleError'
import Cookies from 'js-cookie'
import { MSGBOX_APP_CODE } from '@/utils/constants'
import _ from 'lodash'

Vue.use(Vuex)

function buildMenu(menus, parent) {
  menus.forEach((menu) => {
    if (parent) {
      menu.info.key = `${parent.info['key']}/${menu.info['_id']}`
    } else {
      menu.info.key = menu.info['_id']
    }
    if (menu.children && menu.children.length > 0) {
      buildMenu(menu.children, menu)
    }
  })
}

function buildMenuV2(menus, pined) {
  menus.forEach((menu) => {
    let level1Id = menu.info.id
    menu.info.key = menu.info['_id']
    menu.children.forEach(submenu => {
      submenu.info.key = `${menu.info.key}/${submenu.info['_id']}`
      submenu.children.forEach(item => {
        if(Array.isArray(pined[level1Id]) && pined[level1Id].includes(item.id)) {
          item.pined = true
        } else {
          item.pined = false
        }
        item.key = `${submenu.info.key}/${item['_id']}`
        let info = _.clone(item)
        item.info = info
      })
    })
  })
}

export default new Vuex.Store({
  modules: {
    popHome,
    partnerHome,
    brandHome,
    template,
    dfwHome,
    heatmap
  },
  state: {
    menuList: [],
    userInfo: {},
    cmsConfig: {},
    cmsAdConfig: {},
    businessName: '',
    businessInfo: { store: {}},
    menus: [],
    pinedMenus: {},
    portalMenus: [],
    showFooter: true,
    spinning: true,
    partnerBusinessInfo: {},
    showConfirmModal: false,
    fuwuOrderCount: {},
    modalWhiteInfo: {},
    unifiedTaskSummary: '', // 待办数据
    treeData:[], //菜单数据
    // 消息盒子
    messageFirstMenuList: [],
    messageDetailList: {},
    messageCurrentDetail: {},
    isUggSell: false, // 是否是全球购经销商家
    homeAnnouncementList: [], // 首页最新公告
    showHeatmap: false, // 是否展示热力图
    menuPath: [] // 面包屑导航
  },
  mutations: {
    setUserInfo (state, v) {
      state.userInfo = v
    },
    setCmsConfig(state, data) {
      state.cmsConfig = data
    },
    setCmsAdConfig(state, data) {
      state.cmsAdConfig = data
    },
    setBusinessInfo(state, data) {
      state.businessInfo = data
    },
    setMutation(state, { data, namespace }) {
      state[namespace] = data
    },
    setShowFooter(state, data) {
      state.showFooter = data
    },
    setSpinning(state, dd) {
      state.spinning = dd
    },
    setShowConfirmModal(state, dd) {
      state.showConfirmModal = dd
    },
    setFuwuOrderCount(state, data) {
      state.fuwuOrderCount = data
    },
    setMessageUnReadTotal(state) {
      if (state.messageCurrentDetail && state.messageCurrentDetail.unReadAmount) {
        const unReadAmount = state.messageCurrentDetail.unReadAmount - 1
        state.messageCurrentDetail = { ...state.messageCurrentDetail, unReadAmount}
      }
    },
    setMessageListUnReadCount(state, {activeId, itemId}) {
      const newMessageFirstMenuList = state.messageFirstMenuList.map(item => {
        if (item.id === activeId) {
          if (+item.unreadCount > 0) {
            item.unreadCount -= 1
          } else{
            item.unreadCount = 0
          }
        }
        return item
      })
      // isRead
      const newMessageDetailList = state.messageDetailList.map(item => {
        if (item.id === itemId) {
          item.isRead = 1
        }
        return item
      })
      state.messageFirstMenuList = newMessageFirstMenuList
      state.messageDetailList = newMessageDetailList
    },
    setBatchMessageByReaded(state) {
      const newMessageFirstMenuList = state.messageFirstMenuList.map(item => {
        item.unreadCount = 0
        return item
      })
      const newMessageDetailList = state.messageDetailList.map(item => {
        item.isRead = 1
        return item
      })
      state.messageFirstMenuList = newMessageFirstMenuList
      state.messageDetailList = newMessageDetailList
      if (state.messageCurrentDetail && state.messageCurrentDetail.unReadAmount) {
        state.messageCurrentDetail = { ...state.messageCurrentDetail, unReadAmount: 0}
      }
    },
    setHomeAnnouncementList(state, data) {
      state.homeAnnouncementList = data
    },
    setShowHeatmap(state, data) {
      state.showHeatmap = data
    }
  },
  actions: {
    async checkPortalLogin({ commit, state }) {
      const param = JSON.stringify({
        id: jsCookie.get('id')
      })
      const url = `${host.portal}/portal-api/account/queryAccountInfoNeedLogin.do`
      const json = await $http.post(url, queryString.stringify({param}))
      if (json.code * 1 === 1) {
        commit('setMutation', {
          namespace: 'businessName',
          data: json.data.nickName
        })
        commit('setUserInfo', json.data)
        if (!isLeYou) {
          const heatmapAuthUrl = `${host.cms}/publish/985/btlanuchconfig_ygj.json`
          const heatmapAuthRes = await http.get(heatmapAuthUrl)
          let authList = []
          if (Array.isArray(heatmapAuthRes['hot_user_list'])) {
            authList = heatmapAuthRes['hot_user_list'].map(item => item.loginName)
          }
          let isShowHeatmap = authList.includes(json.data.userName)
          commit('setShowHeatmap', isShowHeatmap)
        }
      } else if (json.code * 1 ===3 || json.code * 1 ===4) {
        toLogin()
      } else {
        Message.error(json.msg)
        !json.report && report({
          url,
          res: json,
          msg: json.msg || '检验门户登陆态失败'
        })
      }
      return json
    },
    /**
     * 登出
     * @returns {Promise<void>}
     */
    async siteOut () {
      await $http.get(`${host.seller}/popAuthLogin/siteOut.do`)
      toLogin()
    },
    //直接掉门户的登出
    async logout() {
      await $http.get(`${host.portal}/portal-api/user/logout.do`)
      toLogin()
    },
    async checkPopLogin ({ commit }) {
      const json = await KWLogin.checkLogin4POPPlatform()
      commit('setUserInfo', json)
    },
    async getCMSConfig({ commit }, { buzzType = 'pop' }) {
      buzzType = buzzType || 'pop'
      const url = `${host.cms}/publish/976/${isLeYou ? 'leyou-' : ''}platform-${buzzType}.json`
      const json = await http.get(url)
      // 拼接顶部菜单子级菜单
      if(Array.isArray(json.navs)) {
        json.navs.forEach(item => {
          if (Array.isArray(json.subNavs)) {
            let children = json.subNavs.filter(sub => item.menuid && item.menuid === sub.parentid)
            item.children = children || []
          } else {
            item.children = []
          }
        })
      } else {
        json.navs = []
      }
      commit('setCmsConfig', json)
    },
    async getCMSAdConfig({ commit }) {
      const url = `${host.cms}/publish/976/${isLeYou ? 'leyou-' : ''}platform-ad.json`
      const json = await http.get(url)
    
      commit('setCmsAdConfig', json)
    },
    async getMenus ({ commit }) {
      const url = `${host.mapi}/admin-b/workbench-menus`
      const json = await $http.get(url)
      // 根据登录的cookie判断，哪些菜单在当前端不展示
      json.forEach(v => {
        v.children = v.children.filter(child => !child.info.hideClient || child.info.hideClient.indexOf(jsCookie.get('loginSourceCode')) === -1)
      })
      // console.log('json====>',json)
      // json.unshift({
      //  info: {
      //   title: '广告中心',
      //   link: 'https://dev.haiziwang.com:8080/platform/ad',
      //   icon: 'https://cmspic-10004025.image.myqcloud.com/00dfd550-2179-11ea-8b50-551bccc0c29f_size_32x32',
      //  },
      // })
      buildMenu(json, null)
      commit('setMutation', {
        namespace: 'menus',
        data: json
      })
    },
    async getMenusV2 ({ commit }) {
      const url = `${host.mapi}/admin-b/workbench-menus/v2`
      const json = await $http.get(url)
      let menus = _.get(json, 'menus')
      let pinedMenus = _.get(json, 'pined')
      // 根据登录的cookie判断，哪些菜单在当前端不展示
      menus.forEach(v => {
        v.children = v.children.filter(child => !child.info.hideClient || child.info.hideClient.indexOf(jsCookie.get('loginSourceCode')) === -1)
      })
      buildMenuV2(menus, pinedMenus)
      commit('setMutation', {
        namespace: 'menus',
        data: menus
      })
      commit('setMutation', {
        namespace: 'pinedMenus',
        data: pinedMenus
      })
    },
    async updatePinedMenus ({ commit, state }, params) {
      const { level1Id, level3Id, pin } = params
      let pinedMenus = state.pinedMenus
      let menus = state.menus
      if (pin) {
        if (Array.isArray(pinedMenus[level1Id])) {
          pinedMenus[level1Id].push(level3Id)
        } else {
          pinedMenus[level1Id] = [level3Id]
        }
      } else {
        if (Array.isArray(pinedMenus[level1Id]) && pinedMenus[level1Id].includes(level3Id)) {
          let index = pinedMenus[level1Id].indexOf(level3Id)
          pinedMenus[level1Id].splice(index, 1)
        }
      }
      await $http.post(`${host.mapi}/admin-b/pined-menus/update`, JSON.stringify({menus: pinedMenus}), {
        headers: {
            'content-Type': 'application/json'
        }
      })
      // 更新state
      buildMenuV2(menus, pinedMenus)
      commit('setMutation', {
        namespace: 'menus',
        data: menus
      })
      commit('setMutation', {
        namespace: 'pinedMenus',
        data: pinedMenus
      })
    },
    async getPortalMenu ({ commit }) {
      const url = `${host.portal}/portal-api/user/getPortalMenu.do`
      const res = await $http.get(url)
      const { code, data, msg } = res || {}
      if (code * 1 === 1) {
        try {
          if(data && data[0] && data[0].children && data[0].children[0] && data[0].children[0].children) {
            commit('setMutation', {
              namespace: 'portalMenus',
              data: data[0].children[0].children
            })
          }
        } catch (e){
          !res.report && report({
            url,
            res,
            msg: '工作台获取账号菜单信息接口异常'
          })
          // eslint-disable-next-line
          console.error(e)
        }
      } else if (code * 1 === 3 || code * 1 === 4 || code * 1 === 2007001) {
        // 未登录
        toLogin()
      } else {
        Message.error(msg)
        !res.report && report({
          url,
          res,
          msg: `工作台获取账号菜单信息接口异常:${msg}`
        })
      }
    },
    // POP商家信息
    async getBusinessInfo({commit}) {
      const url = `${host.popManage}/partners-popmanage-web/mainNew/getBussinessInfo.do`
      const res = await $http.get(url)
      if (res && res.code * 1 === 1) {
        const data = res.data || {}
        commit('setBusinessInfo', data)
        if (+data.business.businessType === 2/*全球购商家*/ && +data.business.salesModel === 2/*经营模式-经销*/) {
          commit('setMutation', { namespace:'isUggSell', data: true })
        }
        return data
      } else if (hasNeedLoginKeyWords(res)) {
        !res.report && report({
          url,
          res,
          msg: '去登陆'
        })
      } else {
        !res.report && report({
          url,
          res,
          msg: '获取商家信息接口异常'
        })
      }
    },
    // check 协同的登陆态
    async checkPartnerLogin({commit}, param) {
      const res = await $http.post(`${host.partner}/partnerAuthLogin/checkUserLogin.do`, queryString.stringify({ ...param }), {
        headers: {
          'content-Type': 'application/x-www-form-urlencoded'
        }
      })
    },
    async doPartnerLogin({commit}) {
      const url = `${host.partner}/partnerAuthLogin/doLogin.do`
      const res = await $http.get(url)
      if (res && res.code === 10000) {
        const { businessCode, businessId, businessName, businessShortName, businessType, supplierCode, supplierStatus, userType} = res.data || {}
        commit('setMutation', {
          namespace: 'partnerBusinessInfo',
          data: res.data
        })
        setCookie('businessCode', Base64.encode(businessCode))
        setCookie('businessId', Base64.encode(businessId))
        setCookie('businessName', Base64.encode(businessName))
        setCookie('businessShortName', Base64.encode(businessShortName))
        setCookie('businessType', Base64.encode(businessType))
        setCookie('supplierCode', supplierCode)
        // setCookie('supplierStatus', Base64.encode(supplierStatus))
        setCookie('userType', Base64.encode(userType))
        report({
          url,
          res,
          msg: '协同工作台获取商户信息成功'
        })
      } else {
        !res.report && report({
          url,
          res,
          msg: '协同工作台商家模拟登陆以及获取商户信息接口异常'
        })
      }
    },
    /**
     * 提交评论
     * b-talk: category_name
     * @returns {Promise<*>}
     */
    async submitCommit ({ commit }, param) {
      const url = `${host.bcomment}/api/v1/caller/btalk/comment/submit`
      const res = await $http.post(url, queryString.stringify({ ...param }), {
        headers: {
          'content-Type': 'application/x-www-form-urlencoded'
        }
      })
      if (res.code * 1 !== 1001) {
        !res.report && report({
          url,
          params: queryString.stringify({ ...param }),
          res,
          msg: '提交评论异常'
        })
      }
      return res
    },
    async queryIsNeedStamp({ commit }) {
      const url = `${host.hbpsupplier}/hbp-supplier-web/hbppc/adContract/queryIsNeedStamp.do`
      const res = await $http.get(url)
      const flag = res.data
      const hasShowed = jsCookie.get('platform_showModal') || ''
      if (flag && !hasShowed ) {
        commit('setShowConfirmModal', flag)
        setCookie('platform_showModal', true)
      }
    },
    async queryModalCMSConfig() {
      const url = `${host.cms}/publish/976/modal-config.json`
      const res = await http.get(url)
      return res
    },
    async getFuwuOrderCount({ commit }) {
      const url = `${host.hbpproduct}/hbp-product-web/api/seller/payOrder/getInternalOrderCount.do`
      const res = await $http.get(url)
      if(res.code === 1 && res.data) {
        commit('setFuwuOrderCount', res.data)
      }
    },
    // 获取统一代办 数据
    async queryUnifiedTaskSummary({commit}) {
      let params = {
        bpId:Cookies.get('buzzId'),
        bpType:Cookies.get('buzzType'),
        bpNo:Cookies.get('siteLoginName'),
        platformNum:Cookies.get('platformNum')
      }
      const url = `${host.hbpworkbench}/hbp-workbench-web/hbppc/unifiedtask/queryUnifiedTaskSummary.do`
      const res = await $http.get(`${url}?${queryString.stringify(params)}`)
      if (res && res.data && Array.isArray(res.data)) {
        commit('setMutation', {namespace:'unifiedTaskSummary', data: res.data})
      } else {
        commit('setMutation', {namespace:'unifiedTaskSummary', data: []})
      }
    },
    // 查询商家大学菜单数据
    async queryTreeData({commit}) {
      let params = {
        bizType: 4,
        sign: '7876e68131ea45478de8d23b475bc462'
      }
      const url = `${host.hbpcollege}/hbp-college/category/manager/categoryTreeData.do`
      const res = await $http.get(`${url}?${queryString.stringify(params)}`)
      if (res && res.data && Array.isArray(res.data)) {
        commit('setMutation', {namespace:'treeData', data: res.data[0].children})
      }
    },
    // 获取消息盒子一级列表
    async getMessageFirstMenuList({commit}) {
      const url = `${host.msgbox}/msgbox-web/outer/msgBoxInterface/querySKYTiconList.do`
      const param = {
        customerId: jsCookie.get('siteLoginName'),
        appCode: MSGBOX_APP_CODE
      }
      const res = await $http.post(url, queryString.stringify(param))
      if (res && res.code * 1 === 0) {
        commit('setMutation', {namespace:'messageFirstMenuList', data: (res.content && res.content.result) || []})
      }
    },
    // 获取消息盒子详情列表
    async getMessageDetailList({commit}, params) {
      const url = `${host.msgbox}/msgbox-web/outer/msgBoxInterface/querySKYTmsgList.do`
      const param = {
        customerId: jsCookie.get('siteLoginName'),
        appCode: MSGBOX_APP_CODE,
        ...params
      }
      const res = await $http.post(url, queryString.stringify(param))
      if (res && res.code * 1 === 0) {
        const arr = res.content && res.content.result && res.content.result.map(item => {
          const content = JSON.parse(item.content) || {}
          if (content.web) {
            Object.assign(content, { ...content.web || {} })
          }
          return {
            ...item,
            ...content || {},
          }
        }) || []
        commit('setMutation', {namespace:'messageDetailList', data: arr})
      }
    },
    // 获取消息盒子最新一条未读通知消息
    async getMessageCurrentDetail({commit}) {
      const url = `${host.msgbox}/msgbox-web/outer/msgBoxInterface/querySKYTLatestmsgdetail.do`
      const param = {
        customerId: jsCookie.get('siteLoginName'),
        appCode: MSGBOX_APP_CODE,
      }
      const res = await $http.post(url, queryString.stringify(param))
      if (res && res.code * 1 === 0) {
        const obj = {}
        if (res.content && res.content.result) {
          const cur = res.content.result
          Object.assign(obj, cur, (cur.content && JSON.parse(cur.content)) || {})
          if (obj.web) {
            Object.assign(obj, {...obj.web || {}})
          }
        }
        commit('setMutation', {namespace:'messageCurrentDetail', data: obj})
      }
    },
    // 修改该消息为已读
    async setMessageStatusByRead({commit}, id) {
      const url = `${host.msgbox}/msgbox-web/outer/msgBoxInterface/reportReadMsgRead.do`
      const param = {
        customerId: jsCookie.get('siteLoginName'),
        msgId: id,
      }
      const res = await $http.post(url, queryString.stringify(param))
      if (res && res.code * 1 === 0) {
        return true
        // commit('setMutation', {namespace:'messageCurrentDetail', data: res.result || {}})
      }
    },
    // 批量修改 消息为已读
    async setBatchMessageByReaded({commit}) {
      const url = `${host.msgbox}/msgbox-web/outer/msgBoxInterface/reportReadMsgListRead.do`
      const param = {
        customerId: jsCookie.get('siteLoginName'),
        appCode: MSGBOX_APP_CODE,
      }
      const res = await $http.post(url, queryString.stringify(param))
      if (res && res.code * 1 === 0) {
        commit('setBatchMessageByReaded')
      }
    },

    // 手动修改消息总数
    setMessageUnReadTotal({commit}) {
      commit('setMessageUnReadTotal')
    },
    // 手动修改消息列表未读数量
    setMessageListUnReadCount({commit}, { activeId, itemId }) {
      commit('setMessageListUnReadCount', { activeId, itemId })
    },

    // 新 — 获取首页公告列表
    async getHomeAfficheList ({commit}) {
      const url = `${host.hbpnotice}/hbp-notice/hbppc/outnet/affiche/list.do?page=1&limit=3`
      const res = await $http.get(url)
      if (res && Array.isArray(_.get(res, 'data'))) {
        commit('setHomeAnnouncementList', _.get(res, 'data'))
      }
    },
    // 新 — 获取公告列表
    async getAfficheList ({commit}, {page, limit}) {
      const url = `${host.hbpnotice}/hbp-notice/hbppc/outnet/affiche/list.do?page=${page}&limit=${limit}`
      const res = await $http.get(url)
      return res
    },
    // 新 — 获取公告详情页
    async getAfficheDetails({commit} , id) {
      const url = `${host.hbpnotice}/hbp-notice/hbppc/outnet/affiche/afficheDetail.do?afficheId=${id}`
      const res = await $http.get(url)
      return res
    },

    async queryCourseList({commit}, params) {
      const url = `${host.hbpcollege}/hbp-college/course/manager/queryCourseList.do`
      const res = await $http.post(url, queryString.stringify(params), {
        headers: {
            'content-Type': 'application/x-www-form-urlencoded'
        }
      })
      return res
    },

    // 设置当前菜单路径
    setCurrentMenuPath({ commit }, data) {
      commit('setMutation', {
        namespace: 'menuPath',
        data
      })
    }
  }
})
